module.exports = __webpack_public_path__ + "img/chinesecompany147.86686188.png";